import { render, staticRenderFns } from "./TagList.vue?vue&type=template&id=c3e06b66&scoped=true&"
import script from "./TagList.vue?vue&type=script&lang=js&"
export * from "./TagList.vue?vue&type=script&lang=js&"
import style0 from "./TagList.vue?vue&type=style&index=0&id=c3e06b66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e06b66",
  null
  
)

export default component.exports